import { useEffect, useState } from "react";
import api from "../lib/api";

/**
 * useBrand (v4.2.4) — single source of truth for the dynamic brand and
 * support contact exposed by `/api/settings/public`. Used by the auth
 * screens and the footer so nothing hardcodes the company name.
 */
export default function useBrand() {
  const [brand, setBrand] = useState({
    brandName: "Brainart Rent",
    supportEmail: "",
    supportPhone: "",
    version: "",
  });

  useEffect(() => {
    api.get("/settings/public")
      .then((r) => setBrand({
        brandName:    r.data?.brand_name || r.data?.company_name || "Brainart Rent",
        supportEmail: r.data?.support_email || "",
        supportPhone: r.data?.support_phone || "",
        version:      r.data?.app_version || "",
      }))
      .catch(() => {});
  }, []);

  return brand;
}
